import classNames from "classnames"
import type { HTMLProps } from "react"
import styles from "./TimeDivider.module.scss"

const strokeWidth = 0.5

export function TimeDivider(props: HTMLProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      className={classNames(
        props.className,
        styles.container,
      )}
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        className={styles.line}
        strokeLinecap="round"
        strokeWidth={strokeWidth}
        strokeDasharray="2, 4"
        x1={strokeWidth / 2}
        y1="0"
        x2={strokeWidth / 2}
        y2="100%"
      />
    </svg>
  )
}
